import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "./constants";
export default {
  pt: /*#__PURE__*/_defineProperty({}, STUDY_PLAN_METRICS_TRANSLATION_KEY, {
    STUDY_PLAN: 'Plano de estudos',
    EDIT_STUDY_PLAN: 'Editar plano de estudos',
    EDIT_STUDY_PLAN_SHORT: 'Editar plano',
    // Activity
    ACTIVITY_TITLE: 'Sua atividade nas aulas',
    MINUTE_COUNT: '{{minutes}} min',
    CURRENT_WEEK: 'Semana de {{startDate}} - {{endDate}}',
    ACTIVITY_EMPTY_LABEL: 'Hora de ir pra aula! Comece bem a semana para alcançar sua meta semanal ⏰',
    ACTIVITY_EMPTY_3_DAYS_LABEL: 'Tudo bem? Não foi registrada nenhuma atividade sua em aulas esta semana 😢',
    ACTIVITY_IN_PROGRESS_LABEL: 'Você está indo em ótimo ritmo! Continue assim e alcançará sua meta semanal 💪',
    ACTIVITY_ALMOST_COMPLETED_LABEL: 'Bom trabalho! Você está prestes a atingir sua meta semanal, vamos lá 👏',
    ACTIVITY_COMPLETED_LABEL: 'Grande esforço! Você alcançou sua meta semanal com sucesso 🎉',
    ACTIVITY_EXCEDED_LABEL: 'Uau, que semana bacana! Você superou sua meta semanal 🎉',
    WEEKLY_TARGET: 'Seu objetivo semanal é de {{minutes}} minutos',
    CHANGE_WEEKLY_TARGET: 'Se sua meta semanal de {{minutes}} minutos não estiver funcionando, você pode modificá-la ',
    CHANGE_WEEKLY_TARGET_CTA: 'aqui',
    // Progress
    PROGRESS_TITLE: 'Seu progresso esta semana',
    PROGRESS_EMPTY_LABEL: 'Você ainda não registrou atividade esta semana. Não fique para trás!',
    PROGRESS_EMPTY_5_DAYS_LABEL: 'Você ainda não registrou atividade esta semana. Aproveite o fim de semana para terminar o seu curso.',
    PROGRESS_IN_PROGRESS_LABEL: 'Você acumulou **{{minutes}} minuto** de atividade até agora.',
    PROGRESS_IN_PROGRESS_LABEL_plural: 'Você acumulou **{{minutes}} minuto** de atividade até agora.',
    PROGRESS_COMPLETED_LABEL: 'Incrível! Você já acumulou **{{minutes}} minuto** de atividade até agora.',
    PROGRESS_COMPLETED_LABEL_plural: 'Incrível! Você já acumulou **{{minutes}} minutos** de atividade até agora.',
    // Empty view
    EMPTY_VIEW_TITLE: 'Parece que você ainda não criou seu plano de estudo',
    EMPTY_VIEW_DESC: 'Queremos contribuir para o seu crescimento profissional da melhor maneira. Com um plano de estudo, você poderá se organizar melhor e atingir cada um de seus objetivos na Crehana.',
    EMPTY_VIEW_BUTTON: 'Montar plano de estudo',
    // Error
    STUDY_PLAN_ERROR: 'Ocorreu um erro ao obter as informações do seu plano de estudo',
    STUDY_PLAN_RETRY_BUTTON_LABEL: 'Tente novamente'
  })
};